var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path5, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _path6, _path7, _g, _rect64, _rect65, _rect66, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroKeyboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270.667,
    height: 211.194,
    viewBox: "0 0 270.667 211.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.86 -47.46)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.44 91.667a3.609 3.609 0 00-3.789-3.39L59.87 87.067a3.61 3.61 0 00-3.847 3.331l-.657 81.654a3.611 3.611 0 003.789 3.39l149.783 1.207a3.609 3.609 0 003.842-3.329z",
    fill: "#eaeaea",
    fillRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.424,
    height: 136.615,
    rx: 5.011,
    transform: "rotate(-89.539 108.654 41.8301)",
    fill: "#474a4c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 33.733,
    height: 18.591,
    rx: 7.418,
    transform: "rotate(-180 75.8538 85.822)",
    fill: "#b2b2b2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 148.553 -42.4477)",
    fill: "#888"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 136.5092 -30.5002)",
    fill: "#888"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 130.4873 -24.5274)",
    fill: "#888"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 124.4663 -18.5549)",
    fill: "#888"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 112.423 -6.6077)",
    fill: "#888"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 106.4017 -.6343)",
    fill: "#888"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 100.3783 5.3399)",
    fill: "#888"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 88.335 17.2869)",
    fill: "#888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.485 87.452l148.68.3c2.955.005 5.866-2.57 7.074-5.841l10.179-26.364c1.554-4.206.023-7.726-3.468-7.733L47.345 47.46c-3.49-.007-5.079 3.506-3.592 7.718l10.193 26.394c1.156 3.277 3.584 5.874 6.539 5.88z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.494 87.454l148.716.3c2.956.006 4.524.358 5.7-2.556l11.241-26.066c1.507-3.726-.054-6.842-3.531-6.849l-174.963-.351c-3.477-.006-5.089 3.1-3.641 6.833l10.857 26.08c1.133 2.919 2.665 2.603 5.621 2.609z",
    fill: "#c1c1c1",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.647 83.751l140.846 1.131c2.316.019 5.359-2.43 6.81-5.544l6.493-13.942c1.767-3.795 1.066-7.037-1.627-7.059L53.428 57.021c-2.692-.022-3.45 3.209-1.747 7.032l6.252 14.044c1.397 3.137 4.397 5.635 6.714 5.654z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 152.4454 -38.5214)",
    fill: "#888"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 146.4235 -32.5476)",
    fill: "#888"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 140.4021 -26.5744)",
    fill: "#888"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 134.3812 -20.602)",
    fill: "#888"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 128.3588 -14.6286)",
    fill: "#888"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 122.3375 -8.6553)",
    fill: "#888"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 116.3156 -2.6814)",
    fill: "#888"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 110.2942 3.292)",
    fill: "#888"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 104.2718 9.2653)",
    fill: "#888"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 98.2504 15.2387)",
    fill: "#888"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 92.2285 21.2125)",
    fill: "#888"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 164.742 -26.1934)",
    fill: "#888"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 158.72 -20.2196)",
    fill: "#888"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 152.6982 -14.2459)",
    fill: "#888"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 146.6768 -8.2726)",
    fill: "#888"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 140.6544 -2.2994)",
    fill: "#888"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 134.633 3.6739)",
    fill: "#888"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 128.6111 9.6477)",
    fill: "#888"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 122.5897 15.621)",
    fill: "#888"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 116.5674 21.5942)",
    fill: "#888"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 110.546 27.5674)",
    fill: "#888"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 104.524 33.5412)",
    fill: "#888"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 160.4974 -30.4039)",
    fill: "#888"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 154.4756 -24.4301)",
    fill: "#888"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 148.4548 -18.4578)",
    fill: "#888"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 142.433 -12.485)",
    fill: "#888"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 136.411 -6.5111)",
    fill: "#888"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 130.3896 -.5377)",
    fill: "#888"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 124.3678 5.4361)",
    fill: "#888"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 118.3452 11.4104)",
    fill: "#888"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 112.3228 17.3837)",
    fill: "#888"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 106.3015 23.357)",
    fill: "#888"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 100.2796 29.3307)",
    fill: "#888"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 156.4714 -34.4626)",
    fill: "#888"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 150.4495 -28.4889)",
    fill: "#888"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 144.4287 -22.5166)",
    fill: "#888"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 138.4068 -16.5437)",
    fill: "#888"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 132.385 -10.5699)",
    fill: "#888"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 126.3636 -4.5965)",
    fill: "#888"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 120.3417 1.3774)",
    fill: "#888"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 114.3192 7.3516)",
    fill: "#888"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 108.2968 13.3249)",
    fill: "#888"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 102.2754 19.2982)",
    fill: "#888"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 6.425,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 96.2535 25.272)",
    fill: "#888"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#888",
    d: "M198.487 138.795l-20.8033-.1674.0513-6.3758 20.8033.1674z"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 68.906,
    rx: 1.227,
    transform: "rotate(-89.54 126.6301 19.5291)",
    fill: "#888"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.042,
    rx: 1.227,
    transform: "rotate(-89.538 120.6226 25.4938)",
    fill: "#888"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 108.571 37.5306)",
    fill: "#888"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.54 114.6068 31.4559)",
    fill: "#888"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.54 162.701 -16.2106)",
    fill: "#888"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 168.7478 -22.2866)",
    fill: "#888"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 6.355,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 103.891 25.7651)",
    fill: "#888"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 6.422,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 152.8492 -30.8726)",
    fill: "#888"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 5.188,
    height: 9.117,
    rx: 1.227,
    transform: "rotate(-89.54 158.142 -32.7571)",
    fill: "#888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.926 62.051h18.788z",
    fill: "none",
    stroke: "#ed1c24",
    strokeMiterlimit: 10,
    strokeWidth: 0.659
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.918 62.054l112.047.007zM69.359 66.23l132.841.008zM71.69 70.162l127.9.009z",
    fill: "none",
    stroke: "#4f4642",
    strokeMiterlimit: 10,
    strokeWidth: 0.659
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#4f4642",
    strokeMiterlimit: 10,
    strokeWidth: 0.659
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.39 73.41l124.982.008zM74.056 76.711l121.187.008zM74.906 79.847l118.255.007z"
  }))), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.539 94.1786 11.2872)",
    fill: "#888"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 118.2175 -12.7101)",
    fill: "#888"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 6.014,
    height: 9.102,
    rx: 1.227,
    transform: "rotate(-89.538 142.4847 -36.6344)",
    fill: "#888"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.082 133.646a53.493 53.493 0 00-10.179 14.009.556.556 0 01-.889-.109c2.196-4.859 6.182-11.158 11.068-13.9zm-14.785 5.688a19.924 19.924 0 015.321-5.1 46.119 46.119 0 00-6.712 10.531c-.433.431-.636.12-.725-.164a19.647 19.647 0 012.116-5.268zm26 12.6a3.583 3.583 0 00-4.829 1.53l-3.8 7.321-5.617 3.552-.185-.375 2.369-6.313-.034-.165c3.5-7.468 6.688-13.052 13.6-18.9a2.907 2.907 0 00-3.755-4.438 50.582 50.582 0 00-12.833 16.242.891.891 0 01-.965-.4c3.675-6.976 8.151-12.264 13.587-16.049 1.315-.918 1.277-3.224.359-4.539s-2.365-1.151-3.684-.232c-1.091.764-2.141 1.576-3.165 2.44a2.906 2.906 0 00-3.978-3.616 22.87 22.87 0 00-6.516 4.893 2.584 2.584 0 00-3.869-3.123c-2.365 1.673-5.31 3.966-7.089 6.869a27.78 27.78 0 00-3.178 8.517l-7.341 17.658c-1.083 3.633-.851 5.7.013 8.172-1 1.875-1.875 3.746-2.786 5.609l-.113-.055-1.237 2.286-4.627-2.339-3.712 7.711-1.075 2.234-37.444 72.23h37.365l29.425-57.4-1.02-.514 4.977-9.849-4.589-2.318-3.9-1.968.43-.923 3.452-6.507c.956.43 3.375-.185 5.057-1.281l8.252-6.216 8.471-5.349a3.624 3.624 0 001.268-1.378l4.244-8.184a3.584 3.584 0 00-1.525-4.829z",
    fill: "#939393",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99.495 158.818l2.83-6.209-.909-3.666 2.488-3.481-4.724-.191c-.915.57-1.66.026-2.108-.932-.323-.81-.308-2.068-1.287-2.631-1.939-1.062-2.517-.592-4.173.661-.946 1.153-1.805.27-1.514 0-.007-.142-.648-.118-.7-.281a3.512 3.512 0 00-1.5-2.477c-1.694-.975-2.4-.823-3.85.272-.868.777-1.009-.414-1.009-.414s-1.223.869-1.413.619c-.238-.418.023-1.41-.473-1.718a6.5 6.5 0 00-1.3-.48 3.044 3.044 0 00-1.579.223 2.241 2.241 0 00-.6.337c-.214.131.057-.07-.214.131l-9.666 19.1c-1.3 3.568-1.021 5.6.011 8.034-2.137 3.321-3.841 6.624-6.106 9.907-.7 1.011-2.677 1.731-3.4 2.739-4.321 6.15-5.909 13.715-10.667 19.729l13.013 3.047 17.224-13.108 2.9-6.244 5.17-8.007c1.144.42 4.042-.183 6.054-1.262l11.465-7.1z",
    fill: "#ffb287",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.319 131.682c-9.377 6.516-13.318 12.616-18.3 21.523M101.568 126.027c-11.063 5.268-19.027 21.6-16.816 23.606",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.738
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.191 127.26a24.324 24.324 0 00-7.181 6.007c-3.218 4.31-3.583 9.356-5.6 15.157",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.102
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.261 126.87c-9.371 5.364-15.553 13.454-20.454 23.377",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.738
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.361 164.573l12.356-6.407 5.084-8.047",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.073
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.392 185.87l-17.279-8.85 3.715-6.322 17.357 8.85z",
    fill: "#db926e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.174 226.629l22.847 11.547 4.591 2.322 27.911-55.221-4.583-2.324-22.85-11.544z",
    fill: "#c7d1e0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.174 226.628l22.847 11.548 27.919-55.22-23.93-12.095z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M83.561 195.637l-32.307 63.017H13.86l40.357-77.852 6.7 3.388 14.957 7.561z",
    fill: "#2b333f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.87 191.751l-34.777 66.9H13.949l40.268-77.852 6.7 3.388z",
    fill: "#49555b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.48 150.601a.556.556 0 01-.867.228 53.519 53.519 0 00-11.972-12.513c5.212 2.062 10.007 7.767 12.839 12.285zm5.383-3.706c-.05.294-.209.629-.7.26a46.059 46.059 0 00-8.068-9.53 19.884 19.884 0 015.959 4.339 19.631 19.631 0 012.808 4.932zm31.735 37.9l-.008.005-2.213-3.355-3.864-5.859-4.274 2.942-1.529-2.1-.106.076c-1.154-1.728-2.279-3.46-3.515-5.188.522-2.563.476-4.644-1.087-8.1l-9.651-16.512a27.946 27.946 0 00-4.289-8.016c-2.159-2.634-5.383-4.51-7.953-5.849a2.583 2.583 0 00-3.414 3.611 22.877 22.877 0 00-7.109-3.97 2.908 2.908 0 00-3.456 4.117c-1.129-.716-2.279-1.386-3.464-1.989-1.428-.734-2.886-.708-3.616.72s-.464 3.718.965 4.45c5.9 3.022 11.041 7.662 15.618 14.076a.888.888 0 01-.9.532 50.492 50.492 0 00-14.9-14.366 2.9053 2.9053 0 10-3.123 4.9c7.632 4.859 11.543 9.963 16.019 16.9l-.013.168 3.2 5.939-.135.4-6.048-2.76-4.749-6.743a3.583 3.583 0 00-5.859 4.126l5.306 7.535a3.618 3.618 0 001.441 1.2l9.116 4.16 9.011 5.049c1.811.859 4.294 1.142 5.184.594l4.294 5.98.552.856-3.6 2.478-4.231 2.916 6.258 9.087-.94.648 38.826 55.209h40.226z",
    fill: "#939393",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.322 168.139l12.316 5.49c2.14.8 5.093 1.007 6.17.437l6.2 7.238 3.718 5.8 18.83 10.672 12.486-4.77c-5.525-5.32-8.115-12.6-13.225-18.115-.849-.9-2.909-1.35-3.735-2.257-2.685-2.949-4.818-5.994-7.383-9 .7-2.547.7-4.6-1.07-7.963l-12.147-17.625c-.3-.163 0 0-.231-.1a2.25 2.25 0 00-.645-.251 3.033 3.033 0 00-1.594-.008 6.4 6.4 0 00-1.225.651c-.45.371-.059 1.319-.238 1.764-.155.274-1.483-.423-1.483-.423s.02 1.2-.944.547c-1.58-.891-2.306-.946-3.853.247a3.52 3.52 0 00-1.158 2.657c-.028.169-.667.232-.654.374.326.228-.408 1.218-1.5.2-1.809-1.02-2.445-1.409-4.223-.095-.9.689-.711 1.934-.922 2.78-.315 1.01-.981 1.65-1.964 1.208l-4.655.824 2.934 3.115-.408 3.755 3.64 5.772z",
    fill: "#ffb287",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M159.037 136.436c10.169 5.2 14.895 10.71 21.025 18.867M172.893 128.849c11.671 3.732 21.759 18.839 19.838 21.13",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.738
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M184.334 128.54a24.324 24.324 0 017.922 4.987c3.769 3.838 4.81 8.789 7.588 14.265",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.102
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.407 130.988c10.008 4.054 17.223 11.24 23.413 20.412",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5.738
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M182.245 166.479l-13.105-4.686-6.12-7.29",
    fill: "none",
    stroke: "#ffb287",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.073
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M203.911 185.031l15.931-11.094-4.531-5.764-16.009 11.1z",
    fill: "#db926e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M255.191 219.202l-21.086 14.516-4.236 2.919-35.087-50.966 4.232-2.917 21.086-14.516z",
    fill: "#c7d1e0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M255.19 219.201l-21.086 14.516-35.09-50.963 22.086-15.2z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M282.495 255.362l-.093.261-1.07 3.03H244.12l-44.019-63.249 7.1-4.884 13.174-9.074 6.81-4.691z",
    fill: "#2b333f"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M284.527 258.654h-29.7l-47.629-68.134 13.174-9.074 6.81-4.691 55.216 78.867z",
    fill: "#49555b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroKeyboard);
export default __webpack_public_path__ + "static/media/intro__keyboard.ac81eec875324127b7b61f4be8e7e319.svg";
export { ForwardRef as ReactComponent };